import React, { Fragment, Component } from "react";
import { withFormik, Field } from "formik";
import SubmitButton from "../SubmitButton";
import { FORM_ERRORS } from "../../../texts";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as PropostasActions } from "../../../store/ducks/propostas";
import { Creators as ModalCustomerActions } from "../../../store/ducks/modalCustomer";
import { Creators as ModalActions } from "../../../store/ducks/modal";
import { Creators as StorePageActions } from "../../../store/ducks/PageStores/propostasStores";
import { Creators as StorePageClientesActions } from "../../../store/ducks/PageStores/clientesStores";
import { Creators as ErrorActions } from "../../../store/ducks/error";
import DefaultButton from "../../../components/DefaultButton";
import PrimaryButton from "../../../components/PrimaryButton";
import DatePicker from "react-datepicker";
import moment from "moment";
import api from "../../../services/api";
import {faExclamationCircle} from '@fortawesome/free-solid-svg-icons'
import $ from "jquery";
// eslint-disable-next-line
import mask from "jquery-mask-plugin";
import Currency from "../../Currency";
import { formatMoney } from "../../../helpers";
import Radio from "@material-ui/core/Radio";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ActionButton} from "../../PequisadorTelefones/styles";

const CurrencyInput = ({ field, form, ...rest }) => (
  <Currency {...field} {...rest} />
);

export class Form extends Component {
  state = {
    date:
      this.props.actionProposta === "EDIT" ||
      this.props.actionProposta === "DETAIL"
        ? this.props.propostas.item.date !== null
          ? moment(this.props.propostas.item.date)
          : null
        : this.props.formFieldsPropostas.date,
    cpf_cnpj:
      this.props.actionProposta === "EDIT" ||
      this.props.actionProposta === "DETAIL"
        ? this.props.propostas.item.customer.cpf_cnpj
        : this.props.formFieldsPropostas.cpf_cnpj,
    members: [],
    bank_id:
      this.props.actionProposta === "EDIT" ||
      this.props.actionProposta === "DETAIL"
        ? this.props.propostas.item.convenet.bank_id
        : this.props.formFieldsPropostas.bank_id,
    promotor_id:
      this.props.actionProposta === "EDIT" ||
      this.props.actionProposta === "DETAIL"
        ? this.props.propostas.item.convenet.promoter_id
        : this.props.formFieldsPropostas.promotor_id,
    product_id:
      this.props.actionProposta === "EDIT" ||
      this.props.actionProposta === "DETAIL"
        ? this.props.propostas.item.convenet.product_id
        : this.props.formFieldsPropostas.product_id,
    operation_id:
      this.props.actionProposta === "EDIT" ||
      this.props.actionProposta === "DETAIL"
        ? this.props.propostas.item.convenet.operation_id
        : this.props.formFieldsPropostas.operation_id,
    convenet_id:
      this.props.actionProposta === "EDIT" ||
      this.props.actionProposta === "DETAIL"
        ? this.props.propostas.item.convenet.id
        : this.props.formFieldsPropostas.convenet_id,
    customer_benefit_id:
      this.props.actionProposta === "EDIT" ||
      this.props.actionProposta === "DETAIL"
        ? this.props.propostas.item.customer_benefit_id
        : this.props.formFieldsPropostas.customer_benefit_id,
    loadingMembers: false,
    banks: [],
    loadingBanks: false,
    promotors: [],
    loadingPromotors: false,
    products: [],
    loadingProducts: false,
    operations: [],
    loadingOperations: false,
    convenets: [],
    loadingConvenets: false,
    origins: [],
    loadingOrigins: false,
    customer:
      this.props.actionProposta === "EDIT" ||
      this.props.actionProposta === "DETAIL"
        ? this.props.propostas.item.customer
        : this.props.formFieldsPropostas.customer,
    loadingCustomer: false,
    benefits:
      this.props.actionProposta === "EDIT" ||
      this.props.actionProposta === "DETAIL"
        ? this.props.propostas.item.customer.benefits
        : this.props.formFieldsPropostas.benefits,
    loadingBenefits: false,
    interval: [],
    benefit_selected:
      this.props.actionProposta === "EDIT" ||
      this.props.actionProposta === "DETAIL"
        ? this.props.propostas.item.customer_benefit
        : false,
    hasParticipatingUser: !!this.props.values.participating_user_id,
    participatingUsers: [],
    operationAlert: false
  };
  handleParticipatingUser = () => {
    this.setState({
      hasParticipatingUser: !this.state.hasParticipatingUser
    });
    this.props.values.participating_user_id = "";
  };

  handleChangeStart = date => {
    this.setState({
      date: date
    });
    this.props.values.date = date;
  };
  handleChangeBenefit = id => {
    this.props.values.customer_benefit_id = parseInt(id) ? parseInt(id) : null;
    this.setState({
      customer_benefit_id: id,
      benefit_selected: id
        ? this.state.benefits.find(benefit => benefit.id === parseInt(id))
        : false
    });
  };
  handleChangeBank = id => {
    this.setState({
      bank_id: id,
      promotor_id: "",
      product_id: "0",
      operation_id: "0",
      convenet_id: "0"
    });
    this.setState({ loadingPromotors: true });
    this.props.values.bank_id = id;
    api
      .get(
        `/banks/${id}/promoters?date=${moment(this.state.date).format(
          "DD/MM/YYYY"
        )}`
      )
      .then(data => {
        const { data: promotors } = data;
        this.setState({
          promotors: promotors,
          loadingPromotors: false
        });
      })
      .catch(err => {
        console.log(err);
      });
  };
  handleChangePromotor = id => {
    this.setState({
      promotor_id: id,
      product_id: "0",
      operation_id: "0",
      convenet_id: "0"
    });
    this.setState({ loadingProducts: true });
    this.props.values.promotor_id = id;
    api
      .get(
        `/products/list?date=${moment(this.state.date).format(
          "DD/MM/YYYY"
        )}&bank_id=${this.state.bank_id}&promoter_id=${id}`
      )
      .then(data => {
        const { data: products } = data;
        this.setState({
          products: products,
          loadingProducts: false
        });
      })
      .catch(err => {
        console.log(err);
      });
  };
  handleChangeProduct = id => {
    this.setState({
      product_id: id,
      operation_id: "0",
      convenet_id: "0"
    });
    this.setState({ loadingOperations: true });
    this.props.values.product_id = id;
    api
      .get(
        `/operations/list?date=${moment(this.state.date).format(
          "DD/MM/YYYY"
        )}&bank_id=${this.state.bank_id}&promoter_id=${
          this.state.promotor_id
        }&product_id=${id}`
      )
      .then(data => {
        const { data: operations } = data;
        this.setState({
          operations: operations,
          loadingOperations: false
        });
      })
      .catch(err => {
        console.log(err);
      });
  };
  handleChangeOperation = id => {
    this.setState({
      operation_id: id,
      convenet_id: "0"
    });
    this.setState({ loadingConvenets: true });
    this.props.values.operation_id = id;
    api
      .get(
        `/convenets/list?date=${moment(this.state.date).format(
          "DD/MM/YYYY"
        )}&bank_id=${this.state.bank_id}&promoter_id=${
          this.state.promotor_id
        }&product_id=${this.state.product_id}&operation_id=${id}`
      )
      .then(data => {
        const { data: convenets } = data;
        this.setState({
          convenets: convenets,
          loadingConvenets: false
        });
      })
      .catch(err => {
        console.log(err);
      });

    if (id && this.props.values.customer_id) {
      this.checkOperationInUse();
    }
  };
  handleChangeConvenet = id => {
    this.setState({
      convenet_id: id
    });
    this.props.values.convenet_id = id;
    this.state.convenets.forEach(convenet => {
      if (convenet.id === parseInt(id, 10)) {
        let pivot = [];
        for (
          var i = convenet.initial_interval;
          i <= convenet.finish_interval;
          i++
        ) {
          pivot.push(i);
        }
        this.setState({ interval: pivot });
      }
    });
    this.props.values.convenet_id = id;
  };
  handleBlurCpfCnpj = val => {
    this.setState({ customer: "", benefit_selected: false });
    this.props.values.customer_id = "";
    if (val !== "") {
      this.setState({ loadingCustomer: true, loadingBenefits: true });
      api
        .get(`/customers?cpf=${val}`)
        .then(data => {
          const { data: customer } = data;
          this.setState({
            customer: customer,
            benefits: customer.benefits,
            loadingCustomer: false,
            loadingBenefits: false
          });
          this.props.values.customer_id = customer.id;
          if (this.props.values.operation_id) {
            this.checkOperationInUse();
          }
        })
        .catch(err => {
          this.props.openError(err.response.data.message);
          this.setState({
            customer: "",
            benefits: [],
            loadingCustomer: false,
            loadingBenefits: false
          });
        });
    }
  };
  handleEditCustomer = () => {
    this.props.openCustomer(
      "EDIT_CUSTOMER_SALES",
      this.props.values.customer_id
    );
  };
  handleCreateCustomer = () => {
    this.props.setClienteAction("NEW_CUSTOMER_SALES");
    this.props.openCustomerModal();
  };
  handlePermissions = (permission, title) => {
    if (!permission.includes("DETALHES")) {
      return this.props.permissions.data.indexOf(permission) > -1
        ? true
        : false;
    } else {
      return (
        (this.props.permissions.data.indexOf(`${permission} DOS ${title}`) > -1
          ? true
          : false) ||
        (this.props.permissions.data.indexOf(`${permission} DAS ${title}`) > -1
          ? true
          : false)
      );
    }
  };

  handleMountParticipatingUsers = () => {
    this.setState({
      participatingUsers: this.state.members.filter(
        member => member.id != this.props.values.user_id
      )
    });
  };
  componentDidMount() {
    if (this.state.cpf_cnpj) {
      this.handleBlurCpfCnpj(this.state.cpf_cnpj);
    }
    this.props.values.date = this.state.date;
    var options = {
      onKeyPress: function(cep, e, field, options) {
        var masks = ["000.000.000-000", "00.000.000/0000-00"];
        var mask = cep.length > 14 ? masks[1] : masks[0];
        $(".cpf_cnpj").mask(mask, options);
      }
    };
    $(".input-date").mask("00/00/0000");
    $(".cpf_cnpj").mask("000.000.000-00", options);
    let selectedBenefit = parseInt(
      this.props.propostas.item.customer_benefit_id
    )
      ? parseInt(this.props.propostas.item.customer_benefit_id)
      : null;
    if (selectedBenefit) {
      this.setState({
        customer_benefit_id: selectedBenefit,
        benefit_selected: selectedBenefit
          ? this.state.benefits.find(benefit => benefit.id === selectedBenefit)
          : false
      });
    }

    this.setState({ loadingOrigins: true });
    api
      .get(`/origins/select`)
      .then(data => {
        const { data: origins } = data;
        this.setState({
          origins: origins,
          loadingOrigins: false
        });
      })
      .catch(err => {
        console.log(err);
      });
    if (
      this.props.actionProposta === "EDIT" ||
      this.props.actionProposta === "DETAIL" ||
      this.props.values.store_id
    ) {
      this.setState({ loadingMembers: true, loadingBanks: true });
      api
        .get(`/stores/${this.props.values.store_id}/users`)
        .then(data => {
          const { data: members } = data;
          this.setState({
            members: members,
            participatingUsers: members.filter(
              member => member.id != this.props.values.user_id
            ),
            loadingMembers: false
          });
        })
        .catch(err => {
          console.log(err);
        });
      api
        .get(`/banks/list?date=${moment(this.state.date).format("DD/MM/YYYY")}`)
        .then(data => {
          const { data: banks } = data;
          this.setState({
            banks: banks,
            loadingBanks: false
          });
        })
        .catch(err => {
          console.log(err);
        });
      this.handleChangeBank(this.state.bank_id);
      this.handleChangePromotor(this.state.promotor_id);
      this.handleChangeProduct(this.state.product_id);
      this.handleChangeOperation(this.state.operation_id);
      this.handleChangeConvenet(this.state.convenet_id);
    }
  }

  checkOperationInUse = () => {
    if (
      this.props.actionProposta !== "EDIT" &&
      this.props.actionProposta !== "DETAIL"
    ) {
      let customer_id = this.props.values.customer_id;
      let operation_id = this.props.values.operation_id;
      this.setState({
        operationAlert: false
      });
      api
        .get(`/sales/check-operation?customer_id=${customer_id}&operation_id=${operation_id}`)
        .then(data => {
          const sale = data.data.sale;
          if (sale) {
            this.setState({
              operationAlert: true
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  };
  componentDidUpdate(prevProps, prevState) {
    $(".input-date").mask("00/00/0000");
    if (
      prevProps.modalCustomer === true &&
      this.props.modalCustomer === false
    ) {
      if (this.state.customer) {
        api
          .get(`/customers/${this.state.customer.id}`)
          .then(data => {
            const { data: customer } = data;
            this.setState({ benefits: customer.benefits });
          })
          .catch(err => {
            console.log(err);
          });
      }
    }

    if (prevState.date !== this.state.date) {
      this.setState({ loadingBanks: true });
      api
        .get(`/banks/list?date=${moment(this.state.date).format("DD/MM/YYYY")}`)
        .then(data => {
          const { data: banks } = data;
          this.setState({
            banks: banks,
            loadingBanks: false
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
    if (prevProps.values.store_id !== this.props.values.store_id) {
      this.setState({ loadingMembers: true });
      this.props.values.participating_user_id = "";
      api
        .get(`/stores/${this.props.values.store_id}/users`)
        .then(data => {
          const { data: members } = data;
          this.setState({
            members: members,
            loadingMembers: false
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
    if (prevProps.values.user_id !== this.props.values.user_id) {
      this.handleMountParticipatingUsers();
    }
    if (prevProps.values.convenet_id !== this.props.values.convenet_id) {
      this.setState({ loadingBanks: true });
      api
        .get(`/banks/list?date=${moment(this.state.date).format("DD/MM/YYYY")}`)
        .then(data => {
          const { data: banks } = data;
          this.setState({
            banks: banks,
            loadingBanks: false
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
    if (prevState.convenets !== this.state.convenets) {
      this.state.convenets.forEach(convenet => {
        if (convenet.id === parseInt(this.state.convenet_id, 10)) {
          let pivot = [];
          for (
            var i = convenet.initial_interval;
            i <= convenet.finish_interval;
            i++
          ) {
            pivot.push(i);
          }
          this.setState({ interval: pivot });
        }
      });
    }
  }

  componentWillUnmount() {
    if (
      this.props.actionProposta !== "EDIT" &&
      this.props.actionProposta !== "DETAIL"
    ) {
      this.props.values.cpf_cnpj = this.state.cpf_cnpj;
      this.props.setFieldsPropostas(this.props.values);
    }
  }

  render() {
    const props = this.props;
    return (
      <Fragment>
        <form onSubmit={props.handleSubmit} autoComplete="off">
          <fieldset className="mb2">
            <legend>Origem da Proposta</legend>
            <label htmlFor="#">
              Data
              <DatePicker
                id="date"
                selected={this.state.date}
                onChange={this.handleChangeStart}
                className="started_at i-started_at input-date"
                disabled={props.actionProposta === "DETAIL"}
                dateFormat="DD/MM/YYYY"
                withPortal
                fixedHeight
              />
            </label>
            <div className="label-grid">
              <label
                className={
                  !!props.errors.store_id && props.touched.store_id
                    ? "error mr2"
                    : "mr2"
                }
              >
                Loja
                <Field
                  component="select"
                  name="store_id"
                  disabled={
                    props.actionProposta === "DETAIL" ||
                    this.state.date === null ||
                    this.state.date === undefined
                  }
                >
                  {this.state.date === null || this.state.date === undefined ? (
                    <option value="">Selecione uma data</option>
                  ) : (
                    <Fragment>
                      <option value="">
                        {props.loadingLojas
                          ? "Carregando..."
                          : props.totalLojas > 0
                          ? "Selecione"
                          : "Nenhum cadastro encontrado"}
                      </option>
                      {props.lojas.map(loja => (
                        <option key={loja.id} value={loja.id}>
                          {loja.name}
                        </option>
                      ))}
                    </Fragment>
                  )}
                </Field>
                <span>{props.errors.store_id && props.errors.store_id}</span>
              </label>
              <label
                className={
                  !!props.errors.user_id && props.touched.user_id ? "error" : ""
                }
              >
                Vendedor
                <Field
                  component="select"
                  name="user_id"
                  disabled={
                    props.actionProposta === "DETAIL" ||
                    props.values.store_id === "" ||
                    this.state.date === null ||
                    this.state.members.length === 0
                  }
                >
                  {props.values.store_id === "" ||
                  props.values.store_id === undefined ? (
                    <option value="">Selecione uma loja</option>
                  ) : (
                    <Fragment>
                      <option value="">
                        {this.state.loadingMembers
                          ? "Carregando..."
                          : this.state.members.length > 0
                          ? "Selecione"
                          : "Nenhum cadastro encontrado"}
                      </option>
                      {this.state.members.map(member => (
                        <option key={member.id} value={member.id}>
                          {member.name}
                        </option>
                      ))}
                    </Fragment>
                  )}
                </Field>
                <span>{props.errors.user_id && props.errors.user_id}</span>
              </label>
            </div>
            <div className="label-grid">
              <label className="mr2">
                Banco
                <select
                  value={this.state.bank_id}
                  onChange={e => this.handleChangeBank(e.target.value)}
                  disabled={
                    props.actionProposta === "DETAIL" ||
                    props.values.user_id === undefined
                  }
                >
                  {props.values.user_id === "0" ||
                  props.values.user_id === undefined ? (
                    <option value="0">Selecione um vendedor</option>
                  ) : (
                    <Fragment>
                      <option value="0">
                        {this.state.loadingBanks
                          ? "Carregando..."
                          : this.state.banks.length > 0
                          ? "Selecione"
                          : "Nenhum cadastro encontrado"}
                      </option>
                      {this.state.banks.map(bank => (
                        <option key={bank.id} value={bank.id}>
                          {bank.name}
                        </option>
                      ))}
                    </Fragment>
                  )}
                </select>
              </label>

              <label className="mr2">
                Promotora
                <select
                  value={this.state.promotor_id}
                  onChange={e => this.handleChangePromotor(e.target.value)}
                  disabled={
                    props.actionProposta === "DETAIL" ||
                    this.state.bank_id === "0" ||
                    this.state.bank_id === undefined
                  }
                >
                  {this.state.bank_id === "0" ||
                  this.state.bank_id === undefined ? (
                    <option value="">Selecione um banco</option>
                  ) : (
                    <Fragment>
                      <option value="">
                        {this.state.loadingPromotors
                          ? "Carregando..."
                          : this.state.promotors.length > 0
                          ? "Selecione"
                          : "Nenhum cadastro encontrado"}
                      </option>
                      <option value="0">Sem Promotora</option>
                      {this.state.promotors.map(promotor => (
                        <option key={promotor.id} value={promotor.id}>
                          {promotor.name}
                        </option>
                      ))}
                    </Fragment>
                  )}
                </select>
              </label>

              <label className="mr2">
                Produto
                <select
                  value={this.state.product_id}
                  onChange={e => this.handleChangeProduct(e.target.value)}
                  disabled={
                    props.actionProposta === "DETAIL" ||
                    this.state.promotor_id === "" ||
                    this.state.promotor_id === undefined
                  }
                >
                  {this.state.promotor_id === "" ||
                  this.state.promotor_id === undefined ? (
                    <option value="0">Selecione uma promotora</option>
                  ) : (
                    <Fragment>
                      <option value="0">
                        {this.state.loadingProducts
                          ? "Carregando..."
                          : this.state.products.length > 0
                          ? "Selecione"
                          : "Nenhum cadastro encontrado"}
                      </option>
                      {this.state.products.map(product => (
                        <option key={product.id} value={product.id}>
                          {product.name}
                        </option>
                      ))}
                    </Fragment>
                  )}
                </select>
              </label>

              <label>
                Operação
                <select
                  value={this.state.operation_id}
                  onChange={e => this.handleChangeOperation(e.target.value)}
                  disabled={
                    props.actionProposta === "DETAIL" ||
                    this.state.product_id === "0" ||
                    this.state.product_id === undefined
                  }
                >
                  {this.state.product_id === "0" ||
                  this.state.product_id === undefined ? (
                    <option value="0">Selecione um produto</option>
                  ) : (
                    <Fragment>
                      <option value="0">
                        {this.state.loadingOperations
                          ? "Carregando..."
                          : this.state.operations.length > 0
                          ? "Selecione"
                          : "Nenhum cadastro encontrado"}
                      </option>
                      {this.state.operations.map(operation => (
                        <option key={operation.id} value={operation.id}>
                          {operation.name}
                        </option>
                      ))}
                    </Fragment>
                  )}
                </select>
              </label>
            </div>
            <div className="label-grid">
              <label
                className={
                  !!props.errors.convenet_id && props.touched.convenet_id
                    ? "error mr2"
                    : "mr2"
                }
              >
                Tabela do Convênio
                <select
                  value={this.state.convenet_id}
                  onChange={e => {
                    props.values.deadline = 0;
                    this.handleChangeConvenet(e.target.value);
                  }}
                  disabled={
                    props.actionProposta === "DETAIL" ||
                    this.state.operation_id === "0" ||
                    this.state.operation_id === undefined
                  }
                >
                  {this.state.operation_id === "0" ||
                  this.state.operation_id === undefined ? (
                    <option value="0">Selecione uma operação</option>
                  ) : (
                    <Fragment>
                      <option value="0">
                        {this.state.loadingConvenets
                          ? "Carregando..."
                          : this.state.convenets.length > 0
                          ? "Selecione"
                          : "Nenhum cadastro encontrado"}
                      </option>
                      {this.state.convenets.map(convenet => (
                        <option key={convenet.id} value={convenet.id}>
                          {convenet.name}
                        </option>
                      ))}
                    </Fragment>
                  )}
                </select>
                <span>
                  {props.errors.convenet_id && props.errors.convenet_id}
                </span>
              </label>
              <label>
                Origem da venda
                <Field
                  component="select"
                  name="origin_id"
                  disabled={
                    props.actionProposta === "DETAIL" ||
                    this.state.date === null
                  }
                >
                  {this.state.date === null ? (
                    <option value="">Selecione uma data</option>
                  ) : (
                    <Fragment>
                      <option value="0">
                        {this.state.loadingOrigins
                          ? "Carregando..."
                          : this.state.origins.length > 0
                          ? "Selecione"
                          : "Nenhum cadastro encontrado"}
                      </option>
                      {this.state.origins.map(origin => (
                        <option key={origin.id} value={origin.id}>
                          {origin.description}
                        </option>
                      ))}
                    </Fragment>
                  )}
                </Field>
              </label>
            </div>
            {this.state.participatingUsers.length > 0 ? (
              <div className="label-grid">
                <div>
                  <label
                    className={
                      !!props.errors.convenet_id && props.touched.convenet_id
                        ? "error mr2 center-item"
                        : "mr2 center-item"
                    }
                  >
                    Adicionar vendedor participante ?
                    <div className={"wrapper participating-user"}>
                      <label className="checkbox-label">
                        <Radio
                          checked={!this.state.hasParticipatingUser}
                          name="has_participating"
                          onChange={this.handleParticipatingUser}
                          classes={{
                            root: "check",
                            checked: "checked"
                          }}
                        />
                        <span className="checkbox-description">Não</span>
                      </label>
                      <label className="checkbox-label">
                        <Radio
                          checked={this.state.hasParticipatingUser}
                          name="has_participating"
                          onChange={this.handleParticipatingUser}
                          classes={{
                            root: "check",
                            checked: "checked"
                          }}
                        />
                        <span className="checkbox-description">Sim</span>
                      </label>
                    </div>
                    <span>
                      {props.errors.convenet_id && props.errors.convenet_id}
                    </span>
                  </label>
                </div>
                {this.state.hasParticipatingUser ? (
                  <label>
                    Vendedor Participante
                    <Field
                      component="select"
                      name="participating_user_id"
                      disabled={
                        props.actionProposta === "DETAIL" ||
                        props.values.user_id === "" ||
                        this.state.date === null
                      }
                    >
                      {props.values.user_id === "" ||
                      props.values.user_id === undefined ? (
                        <option value="">Selecione um vendendor</option>
                      ) : (
                        <Fragment>
                          <option value="">
                            {this.state.loadingMembers
                              ? "Carregando..."
                              : this.state.members.length > 1
                              ? "Selecione"
                              : "Nenhum cadastro encontrado"}
                          </option>
                          {this.state.participatingUsers.map(user => (
                            <option key={user.id} value={user.id}>
                              {user.name}
                            </option>
                          ))}
                        </Fragment>
                      )}
                    </Field>
                  </label>
                ) : (
                  ""
                )}
              </div>
            ) : (
              ""
            )}
          </fieldset>
          <fieldset className="mb2">
            <legend>Dados da proposta</legend>
            {this.state.customer && this.state.customer.name && (
              <div className="label-grid flex-start">
                <span className="spanLabel label-blue">
                  {this.state.customer.name}
                </span>
              </div>
            )}
            <div className="label-grid flex-start">
              <label
                className={
                  !!props.errors.customer_id && props.touched.customer_id
                    ? "i-cpf_cnpj error"
                    : "i-cpf_cnpj"
                }
              >
                CPF/CNPJ do Cliente
                <input
                  type="text"
                  value={this.state.cpf_cnpj}
                  onChange={e => this.setState({ cpf_cnpj: e.target.value })}
                  onBlur={e => this.handleBlurCpfCnpj(e.target.value)}
                  className=" cpf_cnpj"
                  disabled={props.actionProposta === "DETAIL"}
                />
                <span>
                  {props.errors.customer_id && props.errors.customer_id}
                </span>
              </label>
              <label className="align-self-center mt0 ml2 i-button-big">
                {this.state.loadingCustomer
                  ? "Carregando..."
                  : !this.state.customer
                  ? props.actionProposta !== "DETAIL" &&
                    this.handlePermissions(`CADASTRAR CLIENTES`) && (
                      <PrimaryButton
                        type="button"
                        onClick={() => this.handleCreateCustomer()}
                      >
                        <i className="fa fa-plus-circle mr1" /> Cadastrar novo
                      </PrimaryButton>
                    )
                  : props.actionProposta !== "DETAIL" &&
                    (this.handlePermissions(`EDITAR CLIENTES`) ||
                      this.props.values.editstatus) && (
                      <PrimaryButton
                        type="button"
                        onClick={() => this.handleEditCustomer()}
                      >
                        <i className="fa fa-pencil mr1" /> Editar cliente
                      </PrimaryButton>
                    )}
              </label>
              <label className="align-self-center mt0 ml2">
                {this.state.customer && this.state.customer.dead ? (
                  <p
                    style={{
                      fontWeight: "bold",
                      color: "#f86c6b"
                    }}
                  >
                    Este cliente consta como falecido.
                  </p>
                ) : null}
                {this.state.customer && this.state.customer.blacklisted ? (
                  <p
                    style={{
                      fontWeight: "bold",
                      color: "#f86c6b"
                    }}
                  >
                    Este cliente consta na lista negra.
                  </p>
                ) : null}
              </label>
            </div>
            {this.state.benefit_selected &&
              this.state.benefit_selected.bank_account && (
                <div className="label-grid flex-start mt1">
                  {this.state.benefit_selected.bank_account.type && (
                    <label className="form-propostas-info-beneficios">
                      Tipo Conta
                      <span className="spanLabel label-blue">
                        {this.state.benefit_selected.bank_account.type}
                      </span>
                    </label>
                  )}
                  {this.state.benefit_selected.bank_account.bank && (
                    <label className="form-propostas-info-beneficios">
                      Banco
                      <span className="spanLabel label-blue">
                        {this.state.benefit_selected.bank_account.bank.name}
                      </span>
                    </label>
                  )}
                  {this.state.benefit_selected.bank_account.agency && (
                    <label className="form-propostas-info-beneficios">
                      Agência
                      <span className="spanLabel label-blue">
                        {this.state.benefit_selected.bank_account.agency}
                      </span>
                    </label>
                  )}
                  {this.state.benefit_selected.bank_account.account_number && (
                    <label className="form-propostas-info-beneficios">
                      Número Conta
                      <span className="spanLabel label-blue">
                        {
                          this.state.benefit_selected.bank_account
                            .account_number
                        }
                      </span>
                    </label>
                  )}
                </div>
              )}
            <div className="label-grid mt0">
              <label className="mr2">
                Benefício
                <select
                  value={this.state.customer_benefit_id}
                  onChange={e => this.handleChangeBenefit(e.target.value)}
                  disabled={
                    props.actionProposta === "DETAIL" || !this.state.customer
                  }
                >
                  {!this.state.customer ? (
                    <option value="">Digite o CPF/CNPJ do cliente</option>
                  ) : (
                    <Fragment>
                      <option value="0">
                        {this.state.loadingBenefits
                          ? "Carregando..."
                          : this.state.benefits.length > 0
                          ? "Selecione"
                          : "Nenhum benefício encontrado"}
                      </option>
                      {this.state.benefits.map(benefit => (
                        <option key={benefit.id} value={benefit.id}>
                          {benefit.number}
                        </option>
                      ))}
                    </Fragment>
                  )}
                </select>
              </label>
              <label className="mr2">
                Número proposta
                <Field
                  name="sale_number"
                  disabled={props.actionProposta === "DETAIL"}
                />
              </label>
              <label className="mr2">
                Número contrato
                <Field
                  name="contract_number"
                  disabled={props.actionProposta === "DETAIL"}
                />
              </label>
              <label>
                Portabilidade?
                <Field
                  component="select"
                  name="has_portability"
                  disabled={props.actionProposta === "DETAIL"}
                >
                  <option>SELECIONE</option>
                  <option value="0">Não</option>
                  <option value="1">Sim</option>
                </Field>
              </label>
            </div>
            <div className="label-grid">
              <label className="mr2">
                Valor financiado
                <Field
                  name="value_financed"
                  component={CurrencyInput}
                  disabled={props.actionProposta === "DETAIL"}
                  decimalSeparator=","
                  thousandSeparator="."
                  prefix="R$ "
                  onBlur={e => {
                    if (props.actionProposta === "NEW") {
                      props.values.value_released =
                        formatMoney(e.target.value) -
                          formatMoney(props.values.value_debit) >
                        0
                          ? formatMoney(e.target.value) -
                            formatMoney(props.values.value_debit)
                          : 0;
                      this.forceUpdate();
                    }
                  }}
                />
              </label>
              <label className="mr2">
                Valor dívida
                <Field
                  name="value_debit"
                  component={CurrencyInput}
                  disabled={props.actionProposta === "DETAIL"}
                  decimalSeparator=","
                  thousandSeparator="."
                  prefix="R$ "
                  onBlur={e => {
                    if (props.actionProposta === "NEW") {
                      props.values.value_released =
                        formatMoney(props.values.value_financed) -
                          formatMoney(e.target.value) >
                        0
                          ? formatMoney(props.values.value_financed) -
                            formatMoney(e.target.value)
                          : 0;
                      this.forceUpdate();
                    }
                  }}
                />
              </label>
              <label className="mr2">
                Valor liberado
                <Field
                  name="value_released"
                  component={CurrencyInput}
                  disabled={props.actionProposta === "DETAIL"}
                  decimalSeparator=","
                  thousandSeparator="."
                  prefix="R$ "
                />
              </label>
              <label className="mr2">
                Valor parcela
                <Field
                  name="value_installment"
                  component={CurrencyInput}
                  disabled={props.actionProposta === "DETAIL"}
                  decimalSeparator=","
                  thousandSeparator="."
                  prefix="R$ "
                />
              </label>
              <label
                className={
                  !!props.errors.deadline && props.touched.deadline
                    ? "error"
                    : ""
                }
              >
                Prazo
                <Field
                  component="select"
                  name="deadline"
                  disabled={
                    props.actionProposta === "DETAIL" ||
                    !props.values.convenet_id
                  }
                >
                  {!props.values.convenet_id ? (
                    <option value="0">Selecione o convênio</option>
                  ) : (
                    <Fragment>
                      <option value="0">
                        {this.state.loadingConvenets
                          ? "Carregando..."
                          : this.state.convenets.length > 0
                          ? "Selecione"
                          : "Nenhum prazo encontrado"}
                      </option>
                      {this.state.interval.map(i => (
                        <option key={i} value={i}>
                          {i}
                        </option>
                      ))}
                    </Fragment>
                  )}
                </Field>
                <span>{props.errors.deadline && props.errors.deadline}</span>
              </label>
            </div>
          </fieldset>
          {props.values.has_portability &&
            props.values.has_portability === "1" && (
              <fieldset className="mb2">
                <legend>Dados da portabilidade</legend>
                <div className="label-grid">
                  <label className="mr2">
                    Banco
                    <select
                      type="text"
                      name="sale_portability_bank_id"
                      value={props.values.sale_portability_bank_id}
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                      className="bank_id i-bank_id"
                      disabled={
                        props.actionProposta === "DETAIL" ||
                        props.totalBancos === 0
                      }
                    >
                      <option value="0">
                        {props.loadingBancos
                          ? "Carregando..."
                          : props.totalBancos > 0
                          ? "Selecione"
                          : "Nenhum cadastro encontrado"}
                      </option>
                      {props.bancos.map(banco => (
                        <option key={banco.id} value={banco.id}>
                          {banco.name}
                        </option>
                      ))}
                    </select>
                  </label>
                  <label className="mr2">
                    Valor parcela
                    <Field
                      name="sale_portability_installment_value"
                      disabled={props.actionProposta === "DETAIL"}
                      component={CurrencyInput}
                      decimalSeparator=","
                      thousandSeparator="."
                      prefix="R$ "
                    />
                  </label>
                  <label className="mr2">
                    Prazo original
                    <Field
                      name="sale_portability_original_deadline"
                      disabled={props.actionProposta === "DETAIL"}
                    />
                  </label>
                  <label className="mr2">
                    Parcelas pagas
                    <Field
                      name="sale_portability_installment_paid"
                      disabled={props.actionProposta === "DETAIL"}
                    />
                  </label>
                  <label>
                    Parcelas restantes
                    <Field
                      name="sale_portability_installment_pendent"
                      disabled={props.actionProposta === "DETAIL"}
                    />
                  </label>
                </div>
                <div className="label-grid">
                  <label className="mr2">
                    Número contrato
                    <Field
                      name="sale_portability_contract_number"
                      disabled={props.actionProposta === "DETAIL"}
                    />
                  </label>
                  <label className="mr2">
                    Valor saldo
                    <Field
                      name="sale_portability_value_debit"
                      disabled={props.actionProposta === "DETAIL"}
                      component={CurrencyInput}
                      decimalSeparator=","
                      thousandSeparator="."
                      prefix="R$ "
                    />
                  </label>
                  <label className="mr2">
                    Valor saldo pago
                    <Field
                      name="sale_portability_value_paid"
                      disabled={props.actionProposta === "DETAIL"}
                      component={CurrencyInput}
                      decimalSeparator=","
                      thousandSeparator="."
                      prefix="R$ "
                    />
                  </label>
                  <label>
                    Data saldo pago
                    <Field
                      name="sale_portability_date_paid"
                      className="input-date"
                      disabled={props.actionProposta === "DETAIL"}
                    />
                  </label>
                </div>
              </fieldset>
            )}
          <fieldset className="mb2">
            <legend>Observações da proposta</legend>
            <Field
              className="mb1 field-password"
              name="sale_notes"
              component="textarea"
              disabled={props.actionProposta === "DETAIL"}
              rows="5"
            />
          </fieldset>
          {this.state.operationAlert && (
            <div style={{
              padding: '1.2rem 1rem',
              background: 'rgb(253, 152, 77)',
              borderRadius: '5px',
              marginBottom: '1rem',
              display: 'flex',
              alignItems: 'center'
            }}>
              <FontAwesomeIcon icon={faExclamationCircle} style={{marginRight: '5px'}}/>
              <b style={{marginRight: '8px'}} >Atenção!</b> Esse cliente tem uma proposta em andamento com a mesma operação selecionada. Verifique antes de continuar. 
            </div>
          )}
          {props.actionProposta !== "DETAIL" && (
            <div
              style={{
                display: "flex"
              }}
            >
              <SubmitButton disabled={props.loading}>
                {props.actionProposta === "NEW" && "Cadastrar"}
                {props.actionProposta === "EDIT" && "Salvar Alterações"}
              </SubmitButton>
              <span className="mr1" />
              <DefaultButton
                disabled={props.loading}
                onClick={() => props.handleClose()}
                border="border"
              >
                Cancelar
              </DefaultButton>
              {props.actionProposta === "EDIT" && (
                <input
                  type="button"
                  style={{
                    marginLeft: "auto",
                    maxWidth: "17.7rem",
                    background: "#f5f5f5",
                    minHeight: "36px",
                    cursor: "pointer"
                  }}
                  className="text-transform-none"
                  onClick={() => {
                    props.setAction("NEW");
                    props.handleSubmit();
                  }}
                  value="Replicar Proposta"
                />
              )}
            </div>
          )}
        </form>
      </Fragment>
    );
  }
}

const PropostasForm = withFormik({
  mapPropsToValues: props => ({
    date:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.date
        : props.formFieldsPropostas.date,
    store_id:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.store_id
        : props.formFieldsPropostas.store_id,
    user_id:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.user_id
        : props.formFieldsPropostas.user_id,
    participating_user_id:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.participating_user_id
        : props.formFieldsPropostas.participating_user_id,
    convenet:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.convenet
        : props.formFieldsPropostas.convenet,
    convenet_id:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.convenet_id
        : props.formFieldsPropostas.convenet_id,
    origin_id:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.origin_id
        : props.formFieldsPropostas.origin_id,
    cpf_cnpj:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.customer.cpf_cnpj
        : props.formFieldsPropostas.cpf_cnpj,
    customer:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.customer
        : props.formFieldsPropostas.customer,
    customer_id:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.customer.id
        : props.formFieldsPropostas.customer_id,
    customer_benefit_id:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.customer_benefit_id
          ? props.propostas.item.customer_benefit_id
          : ""
        : props.formFieldsPropostas.customer_benefit_id,
    sale_number:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.sale_number
        : props.formFieldsPropostas.sale_number,
    contract_number:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.contract_number
        : props.formFieldsPropostas.contract_number,
    has_portability:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.sale_portability
          ? "1"
          : "0"
        : props.formFieldsPropostas.has_portability,
    value_financed:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.value_financed
          ? props.propostas.item.value_financed
          : ""
        : props.formFieldsPropostas.value_financed,
    value_debit:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.value_debit
          ? props.propostas.item.value_debit
          : ""
        : props.formFieldsPropostas.value_debit,
    value_released:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.value_released
          ? props.propostas.item.value_released
          : ""
        : props.formFieldsPropostas.value_released,
    value_installment:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.value_installment
          ? props.propostas.item.value_installment
          : ""
        : props.formFieldsPropostas.value_installment,
    deadline:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.deadline
        : props.formFieldsPropostas.deadline,
    sale_portability_bank_id:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.sale_portability
          ? props.propostas.item.sale_portability.bank_id
          : ""
        : props.formFieldsPropostas.sale_portability_bank_id,
    sale_portability_original_deadline:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.sale_portability
          ? props.propostas.item.sale_portability.original_deadline
          : ""
        : props.formFieldsPropostas.sale_portability_original_deadline,
    sale_portability_installment_value:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.sale_portability
          ? props.propostas.item.sale_portability.installment_value
          : ""
        : props.formFieldsPropostas.sale_portability_original_deadline,
    sale_portability_installment_paid:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.sale_portability
          ? props.propostas.item.sale_portability.installment_paid
          : ""
        : props.formFieldsPropostas.sale_portability_installment_paid,
    sale_portability_installment_pendent:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.sale_portability
          ? props.propostas.item.sale_portability.installment_pendent
          : ""
        : props.formFieldsPropostas.sale_portability_installment_pendent,
    sale_portability_contract_number:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.sale_portability
          ? props.propostas.item.sale_portability.contract_number
          : ""
        : props.formFieldsPropostas.sale_portability_contract_number,
    sale_portability_value_debit:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.sale_portability
          ? props.propostas.item.sale_portability.value_debit
          : ""
        : props.formFieldsPropostas.sale_portability_value_debit,
    sale_portability_value_paid:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.sale_portability
          ? props.propostas.item.sale_portability.value_paid
          : ""
        : props.formFieldsPropostas.sale_portability_value_paid,
    sale_portability_date_paid:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.sale_portability
          ? props.propostas.item.sale_portability.date_paid
            ? moment(props.propostas.item.sale_portability.date_paid).format(
                "DD/MM/YYYY"
              )
            : ""
          : ""
        : props.formFieldsPropostas.sale_portability_date_paid,
    sale_notes:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.sale_notes
        : props.formFieldsPropostas.sale_notes,
    editstatus:
      props.actionProposta === "EDIT" || props.actionProposta === "DETAIL"
        ? props.propostas.item.status && props.propostas.item.status.length > 0
          ? props.propostas.item.status[0].adm_change
          : 0
        : 0
  }),
  validateOnChange: true,
  validateOnBlur: false,
  validate: values => {
    const errors = {};
    if (
      !values.store_id ||
      values.store_id === "" ||
      values.store_id === null ||
      values.store_id === "0"
    ) {
      errors.store_id = FORM_ERRORS.REQUIRED;
    }
    if (
      !values.user_id ||
      values.user_id === "" ||
      values.user_id === null ||
      values.user_id === "0"
    ) {
      errors.user_id = FORM_ERRORS.REQUIRED;
    }
    if (
      !values.convenet_id ||
      values.convenet_id === "" ||
      values.convenet_id === null ||
      values.convenet_id === "0"
    ) {
      errors.convenet_id = FORM_ERRORS.REQUIRED;
    }
    if (
      !values.customer_id ||
      values.customer_id === "" ||
      values.customer_id === null ||
      values.customer_id === "0"
    ) {
      errors.customer_id = FORM_ERRORS.REQUIRED;
    }
    if (
      !values.deadline ||
      values.deadline === "" ||
      values.deadline === null ||
      values.deadline === "0"
    ) {
      errors.deadline = FORM_ERRORS.REQUIRED;
    }
    return errors;
  },
  handleSubmit: (values, { props, setSubmitting, setErrors }) => {
    const date = values.date ? values.date.format("DD/MM/YYYY") : "";
    const id = props.propostas.item.id;
    const store_id = values.store_id;
    const user_id = values.user_id;
    const participating_user_id = values.participating_user_id;
    const convenet_id = values.convenet_id;
    const origin_id = values.origin_id;
    const customer_id = values.customer_id;
    const customer_benefit_id = values.customer_benefit_id;
    const deadline = values.deadline;
    const sale_number = values.sale_number;
    const contract_number = values.contract_number;
    const value_financed = formatMoney(values.value_financed);
    const value_debit = formatMoney(values.value_debit);
    const value_released = formatMoney(values.value_released);
    const value_installment = formatMoney(values.value_installment);
    let sale_portability = null;
    if (values.has_portability === "1") {
      sale_portability = {
        bank_id: values.sale_portability_bank_id,
        contract_number: values.sale_portability_contract_number,
        original_deadline: values.sale_portability_original_deadline,
        installment_value: formatMoney(values.sale_portability_installment_value),
        installment_paid: values.sale_portability_installment_paid,
        installment_pendent: values.sale_portability_installment_pendent,
        value_debit: formatMoney(values.sale_portability_value_debit),
        value_paid: formatMoney(values.sale_portability_value_paid),
        date_paid: values.sale_portability_date_paid
      };
    }
    const sale_notes = values.sale_notes;
    props.actionProposta === "EDIT"
      ? props.editPropostas({
          date,
          store_id,
          user_id,
          participating_user_id,
          convenet_id,
          origin_id,
          customer_id,
          customer_benefit_id,
          sale_number,
          contract_number,
          sale_portability,
          value_financed,
          value_debit,
          value_released,
          value_installment,
          deadline,
          sale_notes,
          id
        })
      : props.addPropostas({
          date,
          store_id,
          user_id,
          participating_user_id,
          convenet_id,
          origin_id,
          customer_id,
          customer_benefit_id,
          sale_number,
          contract_number,
          sale_portability,
          value_financed,
          value_debit,
          value_released,
          value_installment,
          deadline,
          sale_notes
        });
  }
})(Form);
const mapStateToProps = state => ({
  propostas: state.propostas,
  formFieldsPropostas: state.propostasStores.formFieldsPropostas,
  actionProposta: state.propostasStores.actionProposta,
  lojas: state.lojas.dataList,
  loadingLojas: state.lojas.loadingSelect,
  totalLojas: state.lojas.dataList.length,
  bancos: state.bancos.dataList,
  loadingBancos: state.bancos.loadingSelect,
  totalBancos: state.bancos.dataList.length,
  modalCustomer: state.modalCustomer.open,
  permissions: state.permissions,
  loading: state.loading.loading
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...PropostasActions,
      ...StorePageActions,
      ...StorePageClientesActions,
      ...ModalActions,
      ...ModalCustomerActions,
      ...ErrorActions
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(PropostasForm);



// WEBPACK FOOTER //
// ./src/components/Forms/Propostas/index.js